import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { Tag, TagLinkUnlink } from "../types/scheduling/tags";
import { api, schedulingPath } from "./api";
import QueryKeys from "./queryKeys";

class TagsAPI {
  base = schedulingPath("/tags");

  async getTags(smpw = false): Promise<Tag[]> {
    const url = `${this.base}${smpw ? "/smpw" : ""}`;
    return api.get(url).json();
  }

  async upsert(tag: Tag, smpw = false): Promise<Tag> {
    const url = `${this.base}${smpw ? "/smpw" : ""}`;
    return api.put(url, { json: tag }).json();
  }

  async delete(tag_id: number): Promise<Tag> {
    const url = `${this.base}/${tag_id}`;
    return api.delete(url).json();
  }

  async linkUnlink(tlul: TagLinkUnlink, smpw = false) {
    const url = `${this.base}${smpw ? "/smpw" : ""}`;
    return api.post(url, { json: tlul }).json();
  }
}

export function useTags(smpw = false, options?: UseQueryOptions<Tag[], Error>) {
  return useQuery<Tag[], Error>({
    queryKey: [QueryKeys.Tags],
    queryFn: () => tagsAPI.getTags(smpw),
    ...options,
  });
}

export const tagsAPI = new TagsAPI();
